import React from 'react';
import Input from '../../../components/ui/Input';
import { formatCurrencyInput } from '../../../utils/currencyFormatter';

const FixedCostsSection = ({ formData, errors, onChange }) => {
  const handleCurrencyInputChange = (field, rawValue) => {
    const formatted = formatCurrencyInput(rawValue);
    onChange(field, formatted);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-sm">
      <h3 className="text-xl font-bold text-foreground mb-6">Custos do escritório</h3>
      <div className="space-y-5">
        <Input
          label="Fixos Mensais do Escritório"
          type="text"
          inputMode="decimal"
          placeholder="0,00"
          value={formData?.fixosMensaisEscritorio}
          onChange={(e) => handleCurrencyInputChange('fixosMensaisEscritorio', e?.target?.value)}
          error={errors?.fixosMensaisEscritorio}
          description="Contador, aluguel, internet, marketing (sem equipe)"
          className="text-base"
        />
        
        <div className="p-4 bg-muted/50 rounded-lg border border-border">
          <p className="text-sm text-muted-foreground leading-relaxed">
            <strong className="font-semibold">Observação:</strong> Não inclua custos de equipe aqui para evitar duplicidade.
            Custos de equipe devem ser informados na seção "O que você paga na obra".
          </p>
        </div>
      </div>
    </div>
  );
};

export default FixedCostsSection;